(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.factory('Appointment', ['HelperService', 'PatientConstant', 'AppointmentState', 'ContactInfo', 'AppointmentAdditionalInfo', 'RecurrenceWeekOfMonth', 'RecurrenceDuration', 'CallsService', 'AppointmentDetailService', AppointmentFn]);

    // extended model for appointment
    function AppointmentFn(HelperService, PatientConstant, AppointmentState, ContactInfo, AppointmentAdditionalInfo, RecurrenceWeekOfMonth, RecurrenceDuration, CallsService, AppointmentDetailService) {

        var Appointment = function () {

            // values for appointment to make
            this.id = 0;
            this.agendaId;
            this.appointmentDate;
            this.createDate;
            this.duration;
            this.fK_AgendaLabel;
            this.fK_AppointmentType;
            this.fK_DaySchemeTime;
            this.content;
            this.sendConfirmationSMSToPatient;
            this.sendConfirmationMailToClient;
            this.sendConfirmationSMSToClient;
            this.sendConfirmationMailToPatient;
            this.callGuid = null;
            this.callerNumber = null;
            this.additionalAppointmentInfos = [];
            // default values
            this.isOnlineBooking = false;

            // view model
            this.agendaLabel = null;
            this.appointmentType = null;

            // recurrence
            this.fK_AppointmentRecurrence;
            this.recurrence = null;

            // double booking 
            this.doubleBooking = false;

            // user/patient data
            this.patient = {
                updateNewStatus: PatientConstant.New, // update/new status for saving patient
                id: 0,
                caption: '',                
                firstName: '',
                lastName: '',
                name: '', // name for sending to backend
                birthday: null,
                detail: {
                    street: null,
                    streetNumber: null,
                    zipCode: null,
                    location: null,
                    fK_Country: null,
                    // view model
                    country: null
                },

                contactInfos: []
            };

            // recurrence
            this.recurrence = createDefaultRecurrence();
        };

        // init
        Appointment.prototype.init = function (agendaLabelId, daySchemeTimeId, hour, minute, agendaLabelText, agendaLabelColorCaption) {
            var self = this;

            // label
            self.agendaLabel = {
                agendaLabelId: agendaLabelId,
                daySchemeTimeId: daySchemeTimeId,
                hour: hour,
                minute: minute,
                agendaLabelText: agendaLabelText,
                timeCaption: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
                colorCaption: agendaLabelColorCaption,
                appointmentId: null
            };

            // appointment-type -> always null -> prepare object
            self.appointmentType = {
                id: null
            };

        }; // init

        // extend object
        Appointment.prototype.extend = function (appointmentForEdit) {
            var self = this;

            angular.extend(self, appointmentForEdit);

            // set needed values
            if (self.patient.contactInfos === null) { self.patient.contactInfos = []; }
            if (self.patient.detail === null) { self.patient.detail = {}; }
            if (self.additionalAppointmentInfos === null) { self.additionalAppointmentInfos = []; }
            if (self.appointmentContactInfos === null) { self.appointmentContactInfos = []; }

            // update/new status on patient
            self.patient.updateNewStatus = 'Update';

            // view model
            self.agendaLabel = {
                daySchemeTimeId: appointmentForEdit.fK_DaySchemeTime,
                appointmentId: appointmentForEdit.id,
                hour: appointmentForEdit.hour,
                minute: appointmentForEdit.minute
            };
            self.appointmentType = {
                id: appointmentForEdit.fK_AppointmentType,
                existing: true // to declare "edit"-status
            };

            if (!self.recurrence)
                self.recurrence = createDefaultRecurrence();

            // prepare recurrence
            if (self.recurrence.weekOfMonth) {
                // set selected weekOfMonth to constant, so that it's name can be properly shown
                switch (self.recurrence.weekOfMonth) {
                    case RecurrenceWeekOfMonth.First.value:
                        self.recurrence.weekOfMonth = RecurrenceWeekOfMonth.First;
                        break;
                    case RecurrenceWeekOfMonth.Second.value:
                        self.recurrence.weekOfMonth = RecurrenceWeekOfMonth.Second;
                        break;
                    case RecurrenceWeekOfMonth.Third.value:
                        self.recurrence.weekOfMonth = RecurrenceWeekOfMonth.Third;
                        break;
                    case RecurrenceWeekOfMonth.Fourth.value:
                        self.recurrence.weekOfMonth = RecurrenceWeekOfMonth.Fourth;
                        break;
                    case RecurrenceWeekOfMonth.Last.value:
                        self.recurrence.weekOfMonth = RecurrenceWeekOfMonth.Last;
                        break;
                }
            }

            // set saved recurrence duration to vm-constant
            if (self.recurrence.endDate) {
                self.recurrence.durationOption = RecurrenceDuration.EndOnDate;
            }
            else if (self.recurrence.recurrenceCounter) {
                self.recurrence.durationOption = RecurrenceDuration.EndAfterXAppointments;
            }
            else {
                self.recurrence.durationOption = RecurrenceDuration.NoEnd;
            }

            // prepare add. app. infos
            prepareAdditionalAppointmentInfos(self);

        }; // extend

        // prepare the additional appointment infos for view
        function prepareAdditionalAppointmentInfos(self) {
            if (self.additionalAppointmentInfos === null) { return; }
            var list = [];
            // make objects to interact with them
            var i = 0;
            var len = self.additionalAppointmentInfos.length;
            for (i = 0; i < len; i++) {
                var ai = new AppointmentAdditionalInfo();
                ai.extend(self.additionalAppointmentInfos[i]);
                list.push(ai);
            } // for            

            self.additionalAppointmentInfos = list;
        } // prepareAdditionalAppointmentInfos

        // create empty recurrence with needed default values for the view
        function createDefaultRecurrence() {
            return {
                // vm -> once or series
                once: true, // default
                // vm -> no end, till date...
                durationOption: RecurrenceDuration.NoEnd, //default
                id: 0,
                startDate: null,
                period: 0, // 'Daily' - default value
                endDate: null,
                recurrenceCounter: null,
                interval: null,
                weekOfMonth: null
            };
        }

        // prepare for save
        Appointment.prototype.prepareForSave = function (date) {
            var self = this;

            // call guid and number if available
            self = CallsService.setGuidToEntity(self);

            self.fK_AppointmentType = self.appointmentType && self.appointmentType !== null ? self.appointmentType.id : null;
            self.fK_AgendaLabel = self.agendaLabel && self.agendaLabel !== null ? self.agendaLabel.agendaLabelId : null;
            self.fK_DaySchemeTime = self.agendaLabel && self.agendaLabel !== null ? self.agendaLabel.daySchemeTimeId : null;
            self.fK_InternalLocation = !!self.internalLocation ? self.internalLocation.id : null;

            // hide-time
            self.hideTime = self.agendaLabel && self.agendaLabel !== null ? self.agendaLabel.hideTime : false;

            // appointment date (date and time)
            if (self.agendaLabel && self.agendaLabel !== null) {
                date.setHours(self.agendaLabel.hour);
                date.setMinutes(self.agendaLabel.minute);
                date.setSeconds(0);
                date.setMilliseconds(0);
            }

            self.appointmentDate = HelperService.backendDate(date);

            // additional infos
            var i = 0;
            var len = self.additionalAppointmentInfos.length;
            for (i = 0; i < len; i++) {
                self.additionalAppointmentInfos[i].prepareForSave();
            } // for


            // duration (either from input or appointment-type)
            if (!self.duration && 
                 self.appointmentType && 
                 self.appointmentType.duration) {
                self.duration = self.appointmentType.duration;
            }

            // patient
            if (!self.patient.detail) { 
                self.patient.detail = {}; 
            }
            // country id
            self.patient.detail.fK_Country = self.patient.detail && self.patient.detail.country ? self.patient.detail.country.id : null;
            // update or new 
            if (self.patient.updateNewStatus === PatientConstant.New) { self.patient.id = 0; }

            // Contact infos
            i = 0;
            if (self.patient.contactInfos){
                self.appointmentContactInfos = [];
                for (i = 0; i < self.patient.contactInfos.length; i++) {
                    self.patient.contactInfos[i].prepareForSave();
                    self.appointmentContactInfos.push(self.patient.contactInfos[i]);        
                }                            
            }
            
            if (self.patient.birthday && self.patient.birthday === 'Invalid date') { 
                self.patient.birthday = null; 
            }
            
            // keep only the date, time and timezone doesnt matter
            if (self.patient.birthday) {
                self.patient.birthday = moment(self.patient.birthday).format("YYYY-MM-DD");
            }

            // recurrences
            if (self.recurrence && !self.recurrence.once) {

                self.fK_AppointmentRecurrence = self.recurrence.id;
                self.recurrence.startDate = self.appointmentDate;

                // if period hasn't been set explicitly, use default value (= daily)
                if (!self.recurrence.period) {
                    self.recurrence.period = 0;
                }

                // if the constant is assigned, use only it's value for the backend
                if (self.recurrence.weekOfMonth && self.recurrence.weekOfMonth.value) {
                    self.recurrence.weekOfMonth = self.recurrence.weekOfMonth.value;
                }

                delete self.recurrence.once;
                delete self.recurrence.durationOption;
            } // if
            else {
                // if no recurrence options are set, delete the vm-object and set existing fk to null to remove recurrence options for this appointment
                delete self.recurrence;
                self.fK_AppointmentRecurrence = null;
            }

            delete self.patient.caption;
            delete self.patient.updateNewStatus;
            delete self.patient.userContactInfo;
            delete self.patient.contactInfo;
            delete self.patient.title;
            delete self.patient.birthdayCaption;
            delete self.agendaLabel;
            delete self.appointmentType;
            delete self.creator;
            delete self.deleter;
            delete self.patient.detail.country;

        };

        // prepare list of additional appointment infos which are needed for appointment
        Appointment.prototype.setNeededAdditionalInfoTypes = function (additionalinfotypes) {
            if (typeof additionalinfotypes === 'undefined' || additionalinfotypes === null) { return; }
            var self = this;

            // list of additional types to show
            var infos = [];
            var i = 0;
            var len = additionalinfotypes.length;
            for (i = 0; i < len; i++) {
                // only required ones are relevant
                if (additionalinfotypes[i].isRequired === false) { continue; }
                // does the current selected user has this additional info-type ?
                var found = false;
                var j = 0;
                var uLen = self.additionalAppointmentInfos.length;
                for (j = 0; j < uLen; j++) {
                    // compare 
                    if (additionalinfotypes[i].caption === self.additionalAppointmentInfos[j].caption) {
                        found = true;
                        // add to list
                        infos.push(self.additionalAppointmentInfos[j]);
                    } // if
                } // for

                // found ?
                if (!found) {
                    // add additional info to list
                    var ai = new AppointmentAdditionalInfo();
                    ai.init(additionalinfotypes[i]);
                    infos.push(ai);
                } // if

            } // for

            self.additionalAppointmentInfos = infos;
        }; //setNeededAdditionalInfoTypes


        // prepare list of contact-infos which are needed for this appointment
        Appointment.prototype.setNeededContactInfoTypes = function (contactInfoTypesInAppointment) {
            var self = this;

            // depending on agenda-settings -> show needed contact-info-types
            // all existing contact-infos from user will be displayed
            
            self.patient.contactInfos = AppointmentDetailService.generateNeededContactInfoTypes(self.patient.contactInfos, contactInfoTypesInAppointment);

        }; // contactinfos


        return Appointment;
    }
})();